import * as e from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/Pause.es.js";
const o = e.forwardRef((a, r) => /* @__PURE__ */ e.createElement(s, { ref: r, ...a, weights: t }));
o.displayName = "PauseIcon";
const n = o;
export {
  n as Pause,
  o as PauseIcon
};
